import { MouseEvent, useState } from 'react';
import { IconButton, Menu, MenuItem as MuiMenuItem, Typography } from '@mui/material';
import { MenuItem, Nullable } from '@shared';
import { SvgIconComponent } from '@mui/icons-material';
import * as S from './ActionMenu.styled';

type TypeProps = {
  icon: SvgIconComponent;
  items: MenuItem[];
};

export const ActionMenu = ({ icon: Icon, items }: TypeProps) => {
  const [anchorEl, setAnchorEl] = useState<Nullable<HTMLElement>>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleClick} sx={{ alignSelf: 'center' }}>
        <Icon fontSize='small' color='inherit' />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={S.MenuPaperProps}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {items
          .filter((item) => !item.disabled)
          .map(({ icon: Icon, label, onClick = () => null, disabled }) => (
            <MuiMenuItem
              key={label}
              sx={{ gap: 3 }}
              disabled={disabled}
              onClick={(e) => {
                e.stopPropagation();
                handleClose(e);
                onClick();
              }}
            >
              <Icon color='action' />
              <Typography variant='body2'>{label}</Typography>
            </MuiMenuItem>
          ))}
      </Menu>
    </>
  );
};
